import mprompt from '@/view/map/custom/mobileprompt';
export default {
  name: 'zzmobile',
  meta: {
    title: '地图'
  },
  components: {
    mprompt
  },
  data() {
    return {
      promptboxFlag: false,
      promptFlag: false,
      areaList: [{
        title: '金湾',
        url: require('@/assets/map/216022/appindex1.png')
      }, {
        title: '斗门',
        url: require('@/assets/map/216022/appindex2.png')
      }, {
        title: '横琴',
        url: require('@/assets/map/216022/appindex3.png')
      }, {
        title: '鹤洲',
        url: require('@/assets/map/216022/appindex4.png')
      }, {
        title: '香洲',
        url: require('@/assets/map/216022/appindex5.png')
      }, {
        title: '高新',
        url: require('@/assets/map/216022/appindex6.png')
      }]
    };
  },
  mounted() {
    this.judgeOrientation();
    window.addEventListener('orientationchange', this.judgeOrientation);
  },
  watch: {},
  methods: {
    judgeOrientation() {
      if (window.orientation === 180 || window.orientation === 0) {
        // alert('竖屏状态！')
        this.promptboxFlag = true;
        this.setContainerWH();
      }
      if (window.orientation === 90 || window.orientation === -90) {
        // alert('横屏状态！')
        this.promptboxFlag = false;
      }
    },
    windowjudge() {
      let Wwidth = window.innerWidth || document.body.clientWidth;
      let Wheight = window.innerHeight || document.body.clientHeight;
      this.promptFlag = Wwidth > Wheight ? true : false;
    },
    goDetail(val, index) {
      let query = this.$route.query;
      query.id = index;
      this.$router.replace({
        path: '/zzmap',
        query: query
      });
    },
    setContainerWH() {
      let width = window.screen.width;
      let height = window.screen.height;
      if (width < height) {
        let box = document.querySelector('#mapcontainer');
        box.style.width = height + 'px';
        box.style.height = width + 'px';
        box.style.top = (height - width) / 2 + 'px';
        box.style.left = 0 - (height - width) / 2 + 'px';
      }
    }
  }
};